import Component from './EnabledTime.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconEnabledTime', Component);
  },
};
